/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 16:42:23
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DtBrowserModule } from '@ithinkdt/shared/browser';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [CommonModule, DtBrowserModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class DtFooterModule {}
